import { AgGridReact } from 'ag-grid-react';
import { DatePicker, Select } from 'antd';
import moment from 'moment';
import React, { useEffect, useRef } from 'react';
import { useState } from 'react';
import BookAppointMent from '../../../modules/BookAppointMent';
import { AiOutlineCheck } from 'react-icons/ai';
import { BsBackspace } from 'react-icons/bs';
import { MdDoneAll, MdVerifiedUser } from 'react-icons/md';
import { useToasts } from 'react-toast-notifications';
import { Option } from 'antd/lib/mentions';

import CustomDangerButton from '../../ui-elements/Buttons/CustomDangerButton';
import CustomButtons from '../../ui-elements/Buttons/CustomButtons';
import AptHeader from '../../../components/Apt/AptHeader/AptHeader';
import { Tooltip } from '@mui/material';
import { useNavigate } from 'react-router';
import LdcApi from '../../../LdcApis';
import Skelton from '../../../components/Skelton/Skelton';
import { SiMinutemailer } from 'react-icons/si';
import { Button, Form, Modal, Row } from 'react-bootstrap';
import 'react-quill/dist/quill.snow.css';

import dayjs from 'dayjs';

// import SurgeryMailReviewTemplate from '../../components/MailTemplates/SurgeryMailReviewTemplate';
const userInfo = JSON.parse(localStorage.getItem('user_info'));

function FollowUpTracker() {
  const navigate = useNavigate();
  useEffect(() => {
    document.title = 'Follow Up Tracker - LDC';
  });
  const { RangePicker } = DatePicker;
  const dateFormat = 'DD/MM/YYYY';
  const now = new Date();
  const mailRef = useRef();
  const [reviewData, setReviewData] = useState([]);
  const { addToast } = useToasts();
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [allProvitionalApt, setAllProvitionalApt] = useState([]);
  const [showProvisison, setshowProvisison] = useState({
    open: false,
    aptData: null,
  });
  const [startDate, setStartDate] = useState(new Date());
  const users = JSON.parse(localStorage.getItem('user_info'));
  const users_ID = JSON.parse(localStorage.getItem('user'));
  const [isClickCompleted, setIsClickCompleted] = useState(false);
  const [loader, setLoader] = useState(false);
  const [sentMailOpenBool, setSentMailOpenBool] = useState(false);
  const [labLoader, setLabLoader] = useState(false);

  const [followUpTrackerData, setFollowUpTrackerData] = useState([]);
  const [loaderSpinForMailSent, setLoaderSpinForMailSent] = useState(false);
  const [selectRowId, setSelectRowId] = useState({});
  const [selectTemplate, setSelectTemplate] = useState(-1);
  const defaultStartDate = dayjs().subtract(4, 'month').format('YYYY-MM-DD');
  const defaultEndDate = dayjs().format('YYYY-MM-DD');
  const [finalDateRange, setFinalDateRange] = useState({
    startDate: defaultStartDate,
    endDate: defaultEndDate,
  });

  const [DateRangesss, setDateRangess] = useState({
    startDate: defaultStartDate,
    endDate: defaultEndDate,
  });
  const [value, setValue] = useState(``);
  const viewOnly =
    userInfo?.roleName.replace(/\s/g, '').toUpperCase() === 'VIEWONLY';
  const template = [
    ``,
    `<p>Your Feedback Matters: Request for Google Review from London Dermatology clinic.</p><p><br></p><p>Dear ${selectRowId?.name?.split(' ')[0]} ,</p><p><br></p><p>I trust this message finds you well.</p><p><br></p><p>We would like to express our sincere appreciation for choosing the London Dermatology Clinic for your recent medical appointment with our Plastic Surgeon. Your trust in our clinic and in our expert medical team means a lot to us.</p><p><br></p><p>We sincerely hope that your experience with us was pleasant and that you are on the path to a swift recovery.</p><p><br></p><p>As part of our ongoing commitment to providing exceptional care, we kindly ask to share your feedback if possible about your experience with us through a Google review. Your input not only helps us improve our services but also assists others in making informed decisions about choosing an experienced doctor and a reputable healthcare provider.</p><p><br></p><p>To submit a review, please click on the following link:</p><p><a href="https://g.page/r/CQhNcXSv8zldEBM/review" rel="noopener noreferrer" target="_blank">Google Review Page</a></p><p><br></p><p>Should you have any questions or require further assistance, please do not hesitate to contact us. We are here to support you every step of the way.</p><p><br></p><p>Thank you once again for choosing the London Dermatology Clinic. Your feedback is invaluable to us, and we genuinely appreciate your time and consideration.</p><p><br></p><p><br></p><p>Kind Regards,</p><p><br></p><p>Bookings Team</p><p>London Dermatology Clinic</p><p>T : <span style="color: rgb(0, 71, 178);">020 7112 4924</span></p><p>E : info@londondermatologyclinic.com</p><p>W: www.londondermatologyclinic.com</p>`,
    `<p>Your Feedback Matters: Request for Google Review from London Dermatology Clinic.</p><p><br></p><p>Dear ${selectRowId?.name?.split(' ')[0]},</p><p><br></p><p>I trust this message finds you well.</p><p><br></p><p>We would like to express our sincere appreciation for choosing the London Dermatology Clinic for your recent medical appointment with our Dermatologist. Your trust in our clinic and in our expert medical team means a lot to us.</p><p><br></p><p>We sincerely hope that your experience with us was pleasant and that you are on the path to a swift recovery.</p><p><br></p><p>As part of our ongoing commitment to providing exceptional care, we kindly ask to share your feedback if possible about your experience with us through a Google review. Your input not only helps us improve our services but also assists others in making informed decisions about choosing an experienced doctor and a reputable healthcare provider.</p><p><br></p><p>To submit a review, please click on the following link:</p><p><a href="https://g.page/r/CQhNcXSv8zldEBM/review" rel="noopener noreferrer" target="_blank">Google Review Page</a></p><p><br></p><p>Should you have any questions or require further assistance, please do not hesitate to contact us. We are here to support you every step of the way.</p><p><br></p><p>Thank you once again for choosing the London Dermatology Clinic. Your feedback is invaluable to us, and we genuinely appreciate your time and consideration.</p><p><br></p><p><br></p><p>Kind Regards,</p><p><br></p><p>Bookings Team</p><p>London Dermatology Clinic</p><p>T : <span style="color: rgb(0, 71, 178);">020 7112 4924</span></p><p>E : info@londondermatologyclinic.com</p><p>W: www.londondermatologyclinic.com</p>`,
  ];
  const [loading, setLoading] = useState(null);
  const finalDateRangeRef = useRef(finalDateRange);

  const [statusSelect, setStatusSelect] = useState('False');
  const statusSelectRef = useRef(statusSelect);
  const onChange = (dates, dateStrings) => {
    if (!dates || dates.length !== 2) return;

    const startDate = dates[0].format('YYYY-MM-DD');
    const endDate = dates[1].format('YYYY-MM-DD');

    setFinalDateRange({
      startDate,
      endDate,
    });

    setSelectedRange(dates); // Keep UI in sync
  };

  useEffect(() => {
    finalDateRangeRef.current = finalDateRange;
  }, [finalDateRange]);

  useEffect(() => {
    statusSelectRef.current = statusSelect;
  }, [statusSelect]);

  const defaultValue = [dayjs().subtract(4, 'month'), dayjs()];
  const [selectedRange, setSelectedRange] = useState(defaultValue);

  const handleStatusChange = (value) => {
    setStatusSelect(value);
  };
  const fetchFollowUpData = (
    dateRange = finalDateRange,
    status = statusSelect
  ) => {
    setLabLoader(true);

    let formattedStartDate = dateRange.startDate.split('/').reverse().join('/');
    let formattedEndDate = dateRange.endDate.split('/').reverse().join('/');

    const startDate =
      dateRange.startDate === '' ? DateRangesss.startDate : formattedStartDate;
    const endDate =
      dateRange.endDate === '' ? DateRangesss.endDate : formattedEndDate;

    LdcApi({
      method: 'GET',
      url: `TreatmentNotes/GetTreatmentNoteFollowUpTracker?id=&startDate=${startDate}&endDate=${endDate}&status=${status}`,
    })
      .then((res) => {
        console.log('API Response:', res);
        if (Array.isArray(res?.data?.data)) {
          setFollowUpTrackerData(res.data.data);
        } else {
          setFollowUpTrackerData([]);
        }
        setLabLoader(false);
      })
      .catch((err) => {
        console.error('API Error:', err);
        setLabLoader(false);
      });
  };

  // const fetchFollowUpData = () => {
  //   setLabLoader(true);

  //   let formattedStartDate = finalDateRange.startDate
  //     .split('/')
  //     .reverse()
  //     .join('/');
  //   let formattedEndDate = finalDateRange.endDate
  //     .split('/')
  //     .reverse()
  //     .join('/');

  //   const startDate =
  //     finalDateRange.startDate === ''
  //       ? DateRangesss.startDate
  //       : formattedStartDate;
  //   const endDate =
  //     finalDateRange.endDate === '' ? DateRangesss.endDate : formattedEndDate;

  //   LdcApi({
  //     method: 'GET',
  //     url: `TreatmentNotes/GetTreatmentNoteFollowUpTracker?id=&startDate=${startDate}&endDate=${endDate}&status=${statusSelect}`,
  //   })
  //     .then((res) => {
  //       setLabLoader(true);

  //       console.log('API Response:', res);
  //       if (Array.isArray(res?.data?.data)) {
  //         setFollowUpTrackerData(res.data.data);
  //       } else {
  //         setFollowUpTrackerData([]);
  //       }
  //       setLabLoader(false);
  //     })
  //     .catch((err) => {
  //       console.error('API Error:', err);
  //       setLabLoader(false);
  //     });
  // };
  useEffect(() => {
    fetchFollowUpData();
  }, [finalDateRange, DateRangesss, statusSelect]);

  useEffect(() => {
    if (
      (users && users?.roleID === 1) ||
      (users && users?.roleID === 2) ||
      (users && users?.roleID === 3) ||
      (users && users?.roleID === 5) ||
      (users && users?.roleID === 13)
    ) {
      getProvisionalAptByDocId(users_ID && users_ID.id);
    } else {
      getProvisionalApt();
    }
  }, [selectedDate]);
  useEffect(() => {
    if (selectTemplate) {
      setValue(template[Number(selectTemplate)]);
    } else {
      setValue('');
    }
  }, [selectTemplate]);

  const getProvisionalApt = () => {
    // let date = moment(startDate).format('YYYY-MM-DD');
    setLoader(true);
    BookAppointMent.getReviewForAppointMents((response) => {
      if (response?.status == 'success') {
        // let patientAptData = response?.data?.map((item) => {
        //     return { ...item, patientName: `${item.firstName} ${item.lastName}` };
        // });
        setReviewData([...response?.data]);
        const arr = response?.data.filter((item) => {
          return !item.isCompleted;
        });
        setAllProvitionalApt([...arr]);
        setLoader(false);
      }
      if (response?.status?.request?.status === 401) {
        localStorage.clear();
        navigate('/');
      }
    });
  };

  const getProvisionalAptByDocId = (roleID) => {
    // let date = moment(startDate).format('YYYY-MM-DD');
    BookAppointMent.getProvisionalAppointMentsByID(roleID, (response) => {
      if (response?.status == 'success') {
        let patientAptData = response?.data?.map((item) => {
          return { ...item, patientName: `${item.firstName} ${item.lastName}` };
        });
        setAllProvitionalApt(patientAptData);
      }
      if (response?.status?.request?.status === 401) {
        localStorage.clear();
        navigate('/');
      }
    });
  };

  const closeDialog = () => {
    setshowProvisison({ open: false });
  };
  const copyToClipboard = (type, value) => {
    navigator.clipboard.writeText(value);
    addToast(`${type} is copied successfully`, { appearance: 'success' });
  };
  const mailSent = (name, id, sentCount) => {
    if (sentCount < 3) {
      setSentMailOpenBool(true);
      setSelectRowId({ id, name });
    }
  };
  const [columnDefs] = useState([
    {
      headerName: 'Created On',
      field: 'createdOn',
      width: 180,
      minWidth: 150,
      cellRenderer: function (params) {
        const formattedDate = params.value
          ?dayjs(params.value).format('DD/MM/YYYY hh:mm A')

          : '';

        return (
          <p
            className='ag_grid_caps cursors head_td'
            style={{ width: '100%', height: '100%', margin: '0px' }}
          >
            {formattedDate}
          </p>
        );
      },
    },

    {
      headerName: 'Patient Name ',
      field: 'patientsName',
      width: 180,
      minWidth: 150,
      cellRenderer: function (params) {
        console.log('params', params);
        return (
          <p
            className='ag_grid_caps cursors head_td '
            style={{ width: '100%', height: '100%', margin: '0px' , textDecoration: 'underline', }}
            onClick={() =>
              window.open(`/profile/${params.data.patientID}`, '_blank')
            }
            // onClick={() => copyToClipboard(`Patient name`, params.value)}
          >
            {params.data.patientsName } :: {params.data.patientID}
          </p>
        );
      },
    },
    {
      headerName: 'Contact',
      field: 'mobile',
      width: 180,
      minWidth: 150,
      cellRenderer: function (params) {
        return (
          <p
            className='ag_grid_caps cursors head_td '
            style={{ width: '100%', height: '100%', margin: '0px' }}
          >
            {params.data.mobile} / {params.data.email}
          </p>
        );
      },
    },
    {
      headerName: 'Next Follow Up',
      field: 'nextFollowUp',
      width: 180,
      minWidth: 150,
      cellRenderer: function (params) {
        return (
          <p
            className='ag_grid_caps cursors head_td '
            style={{ width: '100%', height: '100%', margin: '0px' }}
          >
            {params.value}
          </p>
        );
      },
    },
    {
      headerName: 'Due Days',
      field: 'dueDays',
      width: 180,
      minWidth: 150,
      cellRenderer: function (params) {
        return (
          <p
            className='ag_grid_caps cursors head_td '
            style={{ width: '100%', height: '100%', margin: '0px' }}
          >
            {params.value}
          </p>
        );
      },
    },
    {
      headerName: 'Completed',
      field: 'isFollowUp',
      width: 180,
      minWidth: 150,
      cellRenderer: function (params) {
        const handleCheckboxChange = async (e) => {
          const newValue = e.target.checked;

          try {
            setLabLoader(true);
            await LdcApi({
              method: 'POST',
              url: 'TreatmentNotes/UpdateTreatmentNoteFollowUpStatus',
              data: {
                id: params.data.id,
                isFollowUp: newValue,
              },
            });

            console.log(`Updated successfully for ID ${params.data.id}`);
            setLabLoader(false);

            // Always use the latest date & status
            fetchFollowUpData(
              finalDateRangeRef.current,
              statusSelectRef.current
            );
          } catch (err) {
            console.error('API update failed:', err);
            setLabLoader(false);
          }
        };

        return (
          <input
            type='checkbox'
            checked={!!params.value}
            onChange={handleCheckboxChange}
          />
        );
      },
    },
  ]);

  const filterCompleted = () => {
    if (!isClickCompleted) {
      //filter those data whose review is completed
      // alert('filter completed');
      const arr = reviewData.filter((item) => {
        return item.isCompleted;
      });
      setAllProvitionalApt([...arr]);
    } else {
      // filter only those data whose review is not completed
      // alert('filter not completed')
      const arr = reviewData.filter((item) => {
        return !item.isCompleted;
      });
      setAllProvitionalApt([...arr]);
    }
    setIsClickCompleted(!isClickCompleted);
  };

  const defaultColDef = {
    flex: 1,
    resizable: true,
    height: 100,
    minWidth: 99,
    autoHeight: true,
    wrapText: true,
    enableColResize: true,
    autoSizeColumns: true,
  };

  return (
    <>
      <div>
        {/* <div className="d-flex justify-content-center mt-2 mb-2">
        <AptHeader startDate={startDate} onCalendar={onCalendar} onChangeDate={onChangeDate} />
      </div> */}
        <div className='shadow p-3 mb-4 bg-body rounded bg-primary text-white d-flex justify-content-center'>
          Follow Up Tracker
        </div>
        <Modal size='md' show={labLoader} centered className='labloader_modal'>
          <Modal.Body>
            <div className='spinner-container'>
              <div className={`loading-spinner`}></div>
            </div>
          </Modal.Body>
        </Modal>
        {/* <div
          style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}
        >
          <CustomButtons
            style={{
              padding: '5px',
              width: 'max-content',
              backgroundColor: isClickCompleted ? `#007bff` : `#fff`,
              color: isClickCompleted ? `#fff` : `#007bff`,
              boxShadow: 'none',
            }}
            variant='primary'
            name={`Completed`}
            onClick={filterCompleted}
          />
        </div> */}

        <div
          className='ag-theme-alpine mt-2'
          style={{ height: '78vh', width: '100%' }}
        >
          <div className='d-flex align-items-center my-4'>
            <div className='d-flex align-items-center mr-4'>
              <b className='mr-2' style={{ color: 'gray' }}>
                Date Range:
              </b>
              <RangePicker
                format={dateFormat}
                onChange={onChange}
                defaultValue={selectedRange}
              />
            </div>

            <Form.Group className='mb-0 d-flex align-items-center'>
              <Form.Label
                className='mb-0 mr-2'
                style={{ color: 'gray', fontSize: '14px', fontWeight: '500' }}
              >
                Status:
              </Form.Label>
              <Select
                defaultValue=''
                placeholder='Select Status'
                className='mb-0'
                style={{ width: 140 }}
                value={statusSelect}
                onChange={handleStatusChange}
              >
                <Option value=''>All</Option>
                <Option value='True'>Completed</Option>
                <Option value='False'>Pending</Option>
              </Select>
            </Form.Group>
          </div>

          {loader ? (
            <Skelton />
          ) : (
            <AgGridReact
              // ref={gridRef}
              rowData={followUpTrackerData}
              columnDefs={columnDefs}
              animateRows={true}
              defaultColDef={defaultColDef}
              // onGridReady={onGridReady}
              pagination={true}
              paginationPageSize={50}
              debounceVerticalScrollbar={true}
              getRowStyle={(params) => {
                if (params.data?.dueDays < 0) {
                  return { backgroundColor: '#fdd2d2' }; // light green background
                }
                return null; // default style
              }}
              // paginationAutoPageSize={true}
            />
          )}
          {/* <DeleteProvisionDialog
            deleteAppointMentData={deleteAppointMentData}
            open={showProvisison.open}
            closeDialog={closeDialog}
            aptDataId={showProvisison.aptData}
          /> */}
        </div>
      </div>
    </>
  );
}

export default FollowUpTracker;
